import { Box, Modal } from "@mui/material";
import { useEffect, useState, type FC } from "react";
import {
  ReactCompareSlider,
  ReactCompareSliderImage,
} from "react-compare-slider";
import { INFER_TASK_TYPE_ENUM, MAGIC_TYPE_ENUM } from "../../utils/constants";

type PreviewModalProps = {
  open: boolean;
  originFileUrl: string;
  magicFileUrl: string;
  onModalClose: () => void;
  type: MAGIC_TYPE_ENUM | INFER_TASK_TYPE_ENUM;
};

export const PreviewModal: FC<PreviewModalProps> = ({
  open,
  originFileUrl,
  magicFileUrl,
  onModalClose,
  type,
}) => {
  const isVideo =
    type === MAGIC_TYPE_ENUM.video ||
    type === INFER_TASK_TYPE_ENUM.imageToVideo;

  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const updateDimensions = () => {
      const img = new Image();
      img.src = originFileUrl;
      img.onload = () => {
        const screenWidth = window.innerWidth;
        const screenHeight = window.innerHeight * 0.9;
        const scaleFactorW = screenWidth / img.width;
        const scaleFactorH = screenHeight / img.height;
        if (scaleFactorH > scaleFactorW) {
          setDimensions({
            width: img.width * scaleFactorW,
            height: img.height * scaleFactorW,
          });
        } else {
          setDimensions({
            width: img.width * scaleFactorH,
            height: img.height * scaleFactorH,
          });
        }
      };
    };

    updateDimensions();
    window.addEventListener("resize", updateDimensions);

    return () => window.removeEventListener("resize", updateDimensions);
  }, [originFileUrl]);

  return (
    <Modal open={open} onClose={onModalClose} disableAutoFocus>
      <Box
        id="preview-modal"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          border: "1px solid black",
        }}
      >
        {!isVideo && originFileUrl && magicFileUrl && (
          <ReactCompareSlider
            itemOne={
              <ReactCompareSliderImage src={originFileUrl} alt="Origin Image" />
            }
            itemTwo={
              <ReactCompareSliderImage src={magicFileUrl} alt="Magic Image" />
            }
            style={{
              width: `${dimensions.width}px`,
              height: `${dimensions.height}px`,
            }}
          />
        )}
        {isVideo && <video src={magicFileUrl} controls autoPlay />}
        {!isVideo && !originFileUrl && magicFileUrl && (
          <img
            src={magicFileUrl}
            alt="魔法图预览"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
            }}
          />
        )}
      </Box>
    </Modal>
  );
};
